module.exports = __webpack_public_path__ + "img/01.03fe7c7e.svg";